<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-12">
          <h6>Dados gravados em {{ usuario.created_at_f }}</h6>
          <h6 v-show="usuario.updated_at">Última edição em {{ usuario.updated_at_f }}</h6>
        </div>
        <div class="col-md-12">
          <label>Unidade</label>
          <input type="text" class="form-control" v-model="usuario.unidade.nome" disabled />
        </div>
        <div class="col-md-12">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="usuario.name" disabled />
        </div>
        <div class="col-md-12">
          <label>E-mail</label>
          <input type="text" class="form-control" v-model="usuario.email" disabled />
        </div>
        <div class="col-md-12">
          <label>CBO</label>
          <input type="text" class="form-control" v-model="usuario.cbo.nome" disabled />
        </div>
        <div class="col-md-4">
          <label>CPF/CNPJ</label>
          <input type="text" class="form-control" v-model="usuario.cpf_cnpj" disabled />
        </div>
        <div class="col-md-4">
          <label>Telefone</label>
          <input type="text" class="form-control" v-model="usuario.cellphone" disabled />
        </div>
        <div class="col-md-4">
          <label>Nível de acesso</label>
          <input type="text" class="form-control" v-model="usuario.access_nivel" disabled />
        </div>
        <div class="col-md-4">
          <label>Login</label>
          <input type="text" class="form-control" v-model="usuario.login" disabled />
        </div>
        <div class="col-md-4">
          <label>ID central</label>
          <input type="text" class="form-control" v-model="usuario.id" disabled />
        </div>
        <div class="col-md-4">
          <label>ID original</label>
          <input type="text" class="form-control" v-model="usuario.original_id" disabled />
        </div>
        <div class="col-md-6 text-left d-flex align-items-end">
          <h5>Última sincronização realizada em {{ usuario.sincronizacao_f }}</h5>
        </div>
        <div class="col-md-6 text-right">
          <hr />
          <router-link to="/usuarios" class="btn btn-back">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      loader: 0,
      usuario: {},
    };
  },
  computed: {},
  methods: {
    getUsuario: function (id) {
      const self = this;
      const api = self.$store.state.api + "usuarios/" + id + '?with[]=unidade&with[]=cbo';

      axios
        .get(api)
        .then((response) => {
          if(response.data.data[0])
          {
            self.usuario = response.data.data[0];
            
            self.setLoader(50);
          }else{
            this.$router.push("/no-item");
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.setLoader(50);

    if (id) {
      self.getUsuario(id);
    } else {
      self.setLoader(50);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>